var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ErrorPage"}},[_c('div',{staticClass:"icon"},[_vm._v("404")]),_c('h2',[_vm._v("頁面不存在")]),_c('p',[_vm._v("您所查詢的網頁不存在或已移除")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("回到首頁")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }